import Debug from 'debug';
import * as React from 'react';
import { Alert, Button, Form, FormControl, FormGroup, FormLabel, Modal, Spinner, Stack } from 'react-bootstrap';
import { NotifyInfo } from '../ancillary/NotifyManager';

const debug = Debug('gfe/au/MfaInput');

interface MfaInputProps {
  returnToSignIn: () => void;
  supplyTOTPCode: (totpCode: string) => void;
  userMessage: NotifyInfo;
}

export const MfaInput = (props: MfaInputProps): React.JSX.Element => {
  const [isLoading, setLoading] = React.useState<boolean>(false);
  const mfaCodeRef = React.useRef<HTMLInputElement | null>(null);
  debug(`MfaInput`);

  const handleFormSubmit = (event: React.FormEvent) => {
    submitMFACode();
    event.preventDefault();
  };

  const submitMFACode = async () => {
    const code = mfaCodeRef.current?.value || '';
    debug(`submitting MFA code: ${code}`);
    try {
      setLoading(true);
      await props.supplyTOTPCode(code);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <Modal show={true} backdrop="static" centered={true}>
      <Modal.Header>
        <Modal.Title>MFA Code</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleFormSubmit}>
          <Stack gap={3}>
            <Alert variant={props.userMessage[1]}>{props.userMessage[0]}</Alert>
            <FormGroup controlId="code">
              <FormLabel>MFA Code</FormLabel>
              <FormControl type="text" autoComplete="off" autoFocus ref={mfaCodeRef} />
            </FormGroup>
            <Stack
              direction="horizontal"
              style={{
                justifyContent: 'flex-end',
              }}
            >
              <Button variant="link" onClick={props.returnToSignIn}>
                Back to log-in
              </Button>
              <Button variant="primary" type="submit">
                {isLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                {!isLoading && 'Submit'}
              </Button>
            </Stack>
          </Stack>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
